import { Divider } from "antd";
import SpepInstructionCard from "./step-instruction-card";

export default function MaterialBulkInstruction() {
  return (
    <div className="linking-group--right--content p-1 pr-12">
      <SpepInstructionCard
        title="Step 1:"
        detail="  To associate an Activity or Submittal, click Edit to open a list here."
        data-testid="material-bulk-instruction-step-1"
      />
      <SpepInstructionCard
        title="Step 2:"
        detail="Click Save to confirm changes."
        data-testid="material-bulk-instruction-step-2"
      />
      <Divider />

      <SpepInstructionCard
        title="Note"
        detail="Individual Materials in your selection may already be linked with different entities, such links are not shown here."
        data-testid="material-bulk-instruction-note-1"
      />
      <SpepInstructionCard
        title=""
        detail="Some materials in your selection may already be linked to common entities, such links are not shown here."
        data-testid="material-bulk-instruction-note-2"
      />
      <SpepInstructionCard
        title=""
        detail="If all the selected materials are linked to a common entity, such links are displayed here."
        data-testid="material-bulk-instruction-note-3"
      />
      <Divider />
      <div className="px-2">
        <b className="mr-1">Changing the Selection</b>
        <div
          className="py-3"
          data-testid="material-bulk-instruction-changing-selection"
        >
          To add or remove items from the Materials selected, go back to the
          Material Log page and reselect the Materials you wish to Bulk Link.
        </div>
      </div>
    </div>
  );
}
